import { MdChat, MdClose } from 'react-icons/md';
import { useEffect, useState } from "react";
import { useSpring, animated } from "react-spring";
import whatsappimg from "../../image/whatsapp.jpeg";
import facebookimg from "../../image/facebook.png";
import githubimg from "../../image/github.png";
import linkedinimg from "../../image/linkedin.png";
import instaimg from "../../image/instagram.jpeg";
import xtwitterimg from "../../image/x(twitter).png";
import gmailimg from "../../image/gmail.png";

const Socials = () => {
    const [socialOpen, setsocial] = useState(false);

  
    const socialopen = () => {
        setsocial(!socialOpen)

    }

    

    const moveUp = useSpring({
        opacity: socialOpen ? 1 : 0,
        config: { duration: 1000 }
    })
    return (
        <div>
            <div className={socialOpen ? "-translate-y-[200px]" : ""}>

                <button onClick={socialopen} className={socialOpen?"py-2 px-2 bg-white rounded-full mb-4":"mb-4 py-2 px-2 bg-white rounded-full animate-bounce hover:animate-none "}>{socialOpen ? <MdClose size={35} className="text-black" /> : <MdChat className="text-yellow-700" size={35} />}</button>
                <animated.div style={moveUp} className={socialOpen ? "flex flex-col space-y-2  " : "hidden"}>
                    <a href="https://wa.me/+2348165459380" className="w-[50px] h-[50px]"><img className="rounded-full" src={whatsappimg} alt="social" /></a>
                    <a href="https://www.facebook.com/profile.php?id=100068156498882" className="w-[50px] h-[50px]"><img className="rounded-full" src={facebookimg} alt="social" /></a>
                    <a href="https://linkedin.com/in/udoka-otsu-526a02265" className="w-[50px] h-[50px]"><img className="rounded-full" src={linkedinimg} alt="social" /></a>
                    <a href="https://github.com/udoka4397" className="w-[50px] h-[50px]"><img className="rounded-full" src={githubimg} alt="social" /></a>
                    <a href="#" className="w-[50px] h-[50px]"><img className="rounded-full" src={xtwitterimg} alt="social" /></a>
                    <a href="#" className="w-[50px] h-[50px]"><img className="rounded-full" src={instaimg} alt="social" /></a>
                    <a href="mailto:otsuudoka@gmail.com" className="w-[50px] h-[50px] "><img className="rounded-full h-full w-full object-fit" src={gmailimg} alt="social" /></a>
                </animated.div>
            </div>
        </div >
    );
}

export default Socials;